"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationInputState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var distance_input_state_1 = require("./distance.input.state");
var input_state_1 = require("./input.state");
var LocationField_input_state_1 = require("./LocationField.input.state");
var number_input_state_1 = require("./number.input.state");
var LocationInputState = /** @class */ (function (_super) {
    tslib_1.__extends(LocationInputState, _super);
    function LocationInputState(label, precision, minimumInputPrecision) {
        if (precision === void 0) { precision = LocationInputState.DEFAULT_PRECISION; }
        if (minimumInputPrecision === void 0) { minimumInputPrecision = LocationInputState.DEFAULT_MINIMUM_INPUT_PRECISION; }
        var _this = _super.call(this, label) || this;
        _this.hideZero = false;
        _this._error = '';
        _this.precision = precision;
        _this.minimumInputPrecision = minimumInputPrecision;
        _this.isLabelShown = false;
        _this.latitude = new LocationField_input_state_1.LocationFieldAngleInputState(i18n_1.T.LAT, precision, minimumInputPrecision, 90);
        _this.longitude = new LocationField_input_state_1.LocationFieldAngleInputState(i18n_1.T.LNG, precision, minimumInputPrecision, 180);
        _this.altitude = new distance_input_state_1.DistanceInputState(i18n_1.T.FIELD_LOCATION_ALT);
        return _this;
    }
    Object.defineProperty(LocationInputState.prototype, "value", {
        get: function () {
            if (this.latitude.value == null || this.longitude.value == null) {
                return null;
            }
            return {
                latitude: this.latitude.value,
                longitude: this.longitude.value,
                altitude: this.altitude.value
            };
        },
        enumerable: false,
        configurable: true
    });
    LocationInputState.equal = function (value1, value2, precision) {
        if (precision === void 0) { precision = LocationInputState.DEFAULT_PRECISION; }
        if (value1 === value2) {
            return true;
        }
        if (value1 == null || value2 == null) {
            return false;
        }
        return number_input_state_1.NumberInputState.equal(value1.latitude, value2.latitude, precision) &&
            number_input_state_1.NumberInputState.equal(value1.longitude, value2.longitude, precision) &&
            number_input_state_1.NumberInputState.equal(value1.altitude, value2.altitude, LocationInputState.DEFAULT_ALTITUDE_PRECISION);
    };
    LocationInputState.prototype.setValue = function (val) {
        if (val == null) {
            this.latitude.setValue(null);
            this.longitude.setValue(null);
            this.altitude.setValue(null);
            return;
        }
        this.latitude.setValue(val.latitude);
        this.longitude.setValue(val.longitude);
        this.altitude.setValue(val.altitude);
    };
    LocationInputState.prototype.hasError = function () {
        return _super.prototype.hasError.call(this) || this.latitude.hasError() || this.longitude.hasError() || this.altitude.hasError();
    };
    Object.defineProperty(LocationInputState.prototype, "error", {
        get: function () {
            // Don't show an error message if one is already being shown
            if (this.latitude.hasError() || this.longitude.hasError() || this.altitude.hasError()) {
                return null;
            }
            if (this.latitude.value != null && this.longitude.value == null) {
                return i18n_1.T.LONGITUDE_MISSING;
            }
            if (this.latitude.value == null) {
                return i18n_1.T.LATITUDE_MISSING;
            }
            return this._error;
        },
        set: function (msg) {
            this._error = msg || '';
        },
        enumerable: false,
        configurable: true
    });
    LocationInputState.prototype.destroy = function () {
        this.latitude.destroy();
        this.longitude.destroy();
        this.altitude.destroy();
        _super.prototype.destroy.call(this);
    };
    LocationInputState.DEFAULT_PRECISION = 7;
    LocationInputState.DEFAULT_MINIMUM_INPUT_PRECISION = 6;
    LocationInputState.DEFAULT_ALTITUDE_PRECISION = 2;
    tslib_1.__decorate([
        mobx_1.computed
    ], LocationInputState.prototype, "value", null);
    tslib_1.__decorate([
        mobx_1.action
    ], LocationInputState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], LocationInputState.prototype, "error", null);
    return LocationInputState;
}(input_state_1.InputState));
exports.LocationInputState = LocationInputState;
//# sourceMappingURL=location.input.state.js.map